<template>
  <v-dialog v-model="show" width="500">
    <v-card class="mt-2">
      <v-card-title primary-title>
        <span class="headline mb-0"
          >バイヤーコード の{{ type === 'EDIT' ? '編集' : '追加' }}</span
        >
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!canSave" @click="save">{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="back()">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form ref="form">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  :disabled="type === 'EDIT'"
                  clearable
                  label="バイヤーコード"
                  required
                  v-model="buyer.code"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  clearable
                  label="部署名称"
                  required
                  v-model="buyer.name"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['company', 'buyerCodes'],
  data() {
    return {
      show: false,
      buyer: {},
      type: null,
      errors: {
        CODE_EXISTS: 'buyerCodeが既存しています。',
      },
    }
  },
  methods: {
    popup(type, buyer) {
      this.show = true
      this.type = type
      this.buyer = buyer
    },
    back() {
      this.clearData()
      this.$emit('refresh')
    },
    clearData() {
      this.show = false
      this.buyer = {}
    },
    validCreateData() {
      if (
        this.buyerCodes.filter((bc) => bc.code === this.buyer.code).length > 0
      ) {
        this.$message('', 'buyerCodeが既存しています。')
        return false
      }
      return true
    },
    validUpdateData() {
      if (
        this.buyerCodes.filter((bc) => bc.code === this.buyer.code).length > 1
      ) {
        this.$message('', 'buyerCodeが既存しています。')
        return false
      }
      return true
    },
    save() {
      if (this.type !== 'EDIT' && !this.validCreateData()) return
      if (this.type !== 'EDIT' && !this.company.companyId) {
        this.$emit('addTempBuyer', this.buyer)
        this.clearData()
        return
      }
      if (this.type === 'EDIT' && !this.validUpdateData()) return
      if (this.type === 'EDIT' && !this.company.companyId) {
        this.clearData()
        return
      }
      if (!this.type || this.type !== 'EDIT') {
        this.$http
          .post(`buyers/code`, {
            ...this.buyer,
            parentCompanyId: this.company.companyId,
          })
          .then(() => {
            this.$message('', 'buyerCode追加しました。')
            this.back()
          })
          .catch((err) => {
            this.$showError(err)
          })
      } else {
        this.$http
          .put(`buyers/code`, {
            ...this.buyer,
            parentCompanyId: this.company.companyId,
          })
          .then(() => {
            this.$message('', 'buyerCode更新しました。')
            this.back()
          })
          .catch((err) => {
            this.$showError(err)
          })
      }
    },
  },
  computed: {
    canSave() {
      return !!(
        this.buyer.code &&
        this.buyer.code.trim() &&
        !!(this.buyer.name && this.buyer.name.trim())
      )
    },
  },
}
</script>
